import AV from 'leancloud-storage'

export const SPECIAL_CHANNEL = {
    DAILY_WORK: AV.Object.createWithoutData('Channel', '56ebd926f3609a00545a5a73'),
    WORK_NOTE: AV.Object.createWithoutData('Channel', '56f5f82a75c4cd4ccfc39ba3'),
    WORK_WRITING: AV.Object.createWithoutData('Channel', '56ebd9b4816dfa0052dc3618'),
    WORK_PAINTING: AV.Object.createWithoutData('Channel', '56ebdd3f731956005d0d557f'),
    WORK_PICTURE: AV.Object.createWithoutData('Channel', '56ebd7ebda2f60004c8218d2'),
    WORK_AUDIO: AV.Object.createWithoutData('Channel', '56ebd9e57db2a20052ff4c96'),
    WORK_MUSIC: AV.Object.createWithoutData('Channel', '58e728258d6d81006174b7f1'),
    WORK_VIDEO: AV.Object.createWithoutData('Channel', '5a431d142f301e003ceb27ff'),
    ORIGINAL_WORK: AV.Object.createWithoutData('Channel', '56ebdbaf731956005c24be9a'),
    SHOP: AV.Object.createWithoutData('Channel', '58ca1ff5570c3500588e9d70'),
}

export const SPECIAL_CHANNEL_ID = {
    DAILY_WORK: '56ebd926f3609a00545a5a73',
    WORK_NOTE: '56f5f82a75c4cd4ccfc39ba3',
    WORK_WRITING: '56ebd9b4816dfa0052dc3618',
    WORK_PAINTING: '56ebdd3f731956005d0d557f',
    WORK_PICTURE: '56ebd7ebda2f60004c8218d2',
    WORK_AUDIO: '56ebd9e57db2a20052ff4c96',
    WORK_VIDEO: '5a431d142f301e003ceb27ff',
    WORK_MUSIC: '58e728258d6d81006174b7f1',
    WORK_ESSAY: '5a25149b0b616000459af427',
    NOVEL: '5b703c4ba22b9d0031849e61',
    ORIGINAL_WORK: '56ebdbaf731956005c24be9a',
    ORIGINAL_NEW_POEM: "5aefccf8fb4ffe0068c149d3",
    SHOP: '58ca1ff5570c3500588e9d70',
}



// WEBPACK FOOTER //
// ./src/utils/constants.js